if(!customElements.get('header-drawer')) {
  customElements.define(
    'header-drawer',
    class HeaderDrawer extends HTMLElement {
      backdrop = null;
      drawer = null;
      triggers = null;
      subMenuTriggers = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.backdrop = this.querySelector('[data-backdrop]');
        this.drawer = this.querySelector('[data-drawer]');
        this.triggers = document.querySelectorAll('[data-header-drawer="trigger"]');
        this.subMenuTriggers = this.querySelectorAll('[data-submenu-trigger]');
        this.backButtons = this.querySelectorAll('[data-back-button]');
        this.mainMenuItems = this.querySelector('[data-menu="main"]').getAttribute('data-items');
        this.init();
      }

      init() {
        if(!this.drawer || !this.triggers.length) return console.error("No triggers or drawer found");

        this.triggers.forEach(trigger => {
          trigger.addEventListener('click', () => {
            if(this.classList.contains('open')) {
              Array.from(this.querySelectorAll('[data-menu]'))
                .filter(menu => menu.getAttribute('data-menu') !== "main")
                .forEach(menu => menu.classList.remove('active'));

              // Wait the css animation to set main menu active again
              setTimeout(() => {
                this.querySelector('[data-menu="main"]')?.classList.add('active');
              }, 200);
            }

            this.classList.toggle('open');
          });
        });

        this.enableSubMenus();
      }

      enableSubMenus() {
        if(!this.subMenuTriggers?.length) return;

        this.subMenuTriggers.forEach(trigger => {
          trigger.addEventListener('click', () => {
            this.querySelector('[data-menu].active')?.classList.remove('active');
            this.querySelector(`[data-menu][data-parent="${trigger.getAttribute('data-submenu-trigger')}"]`)?.classList.add('active');
          });
        });

        if(!this.backButtons?.length) return;

        this.backButtons.forEach(button => {
          button.addEventListener('click', () => {
            const menuType = button.parentNode.getAttribute('data-menu')
            
            // Deactivate current menu
            button.parentNode.classList.remove('active');

            // All submenu back buttons sets main menu active
            if(menuType === "submenu") {
              return this.querySelector('[data-menu="main"]')?.classList.add('active');
            }

            // Handle deep menus
            const parentSubMenu = Array.from(this.querySelectorAll('[data-menu="submenu"]'))
              .find(menu => {
                const deepMenus = menu.getAttribute('data-deep-menus')?.split(',') || [];
                return deepMenus.includes(button.parentNode.getAttribute('data-parent'))
              });

            if(parentSubMenu) parentSubMenu.classList.add('active');
          });
        });
      }
    }
  )
}